import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'components/Popup/popup';
import Form from 'components/react-validation/components/form';
import { Dropdown } from 'components/Dropdown/Dropdown';

class OpenAwaitPopup extends React.Component {
  static propTypes = {
    onFetchItemRepair: PropTypes.func,
    onFetchProblem: PropTypes.func,
    onFetchSubcontractor: PropTypes.func,
    onFetchTrade: PropTypes.func,
    onFetchUser: PropTypes.func,
    itemRepairList: PropTypes.array,
    problemList: PropTypes.array,
    subcontractorList: PropTypes.array,
    userList: PropTypes.array,
    tradeList: PropTypes.array,
    requireFormField: PropTypes.array,
    isOpen: PropTypes.bool,
    onSubmit: PropTypes.func,
    onCancelPopup: PropTypes.func,
    woInformation: PropTypes.object,
    rfsInformation: PropTypes.object,
    workOrderTypeList: PropTypes.array,
    onFetchWOT: PropTypes.func,
    BulkSendWORFSpage: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      trade: null,
      subcontractor: null,
      itemRepair: null,
      problem: null,
      user: {
        value: props.rfsInformation.managedByUser.id,
        text: props.rfsInformation.managedByUser.displayName,
        extensionValue: {email: props.rfsInformation.managedByUser.email},
        selected: false
      },
      tradeList: [],
      itemRepairList: [],
      subcontractorList: [],
      problemList: [],
      userList: [],

      isModeAssignSub: true,

      isLoadingTrade: false,
      isLoadingSubcontractor: false,
      isLoadingUser: false,
      isLoadingItemToRepair: false,
      isLoadingProblem: false,
      isFetchedUser: false,
      wot: null,
      isLoadingWorkOrderType: false
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      tradeList: nextProps.tradeList,
      itemRepairList: nextProps.itemRepairList,
      subcontractorList: nextProps.subcontractorList,
      problemList: nextProps.problemList,
      userList: nextProps.userList
    });
    if (nextProps.tradeList) {this.setState({isLoadingTrade: false});}
    if (nextProps.itemRepairList) {this.setState({isLoadingItemToRepair: false});}
    if (nextProps.subcontractorList) {this.setState({isLoadingSubcontractor: false});}
    if (nextProps.problemList) {this.setState({isLoadingProblem: false});}
    if (nextProps.userList !== this.props.userList) {this.setState({isLoadingUser: false, isFetchedUser: true});}
    if (nextProps.workOrderTypeList) {this.setState({ isLoadingWorkOrderType: false });}
  }

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value
    });
    if (name === 'itemRepair') {
      this.setState({
        problem: null
      });
    }
    if (name === 'trade') {
      this.setState({
        subcontractor: null,
        itemRepair: null,
        problem: null
      });
    }
  }

  handleModeAssign = mode => {
    if (mode === 'sub') {
      this.setState({isModeAssignSub: true});
    } else {
      this.setState({isModeAssignSub: false});
    }
  }

  onFetchTrade = () => {
    this.setState({isLoadingTrade: true});
    this.props.onFetchTrade();
  }

  onFetchUser = () => {
    this.setState({isLoadingUser: true});
    this.props.onFetchUser();
  }

  onFetchSubcontractor = () => {
    if (this.state.trade || this.props.woInformation.trade) {
      const tradeId = this.props.woInformation.trade ? this.props.woInformation.trade.id : this.state.trade.value;
      this.setState({isLoadingSubcontractor: true});
      this.props.onFetchSubcontractor(tradeId);
    }
  }

  onFetchItemRepair = () => {
    if (this.state.trade || this.props.woInformation.trade) {
      const tradeId = this.props.woInformation.trade ? this.props.woInformation.trade.id : this.state.trade.value;
      this.setState({isLoadingItemToRepair: true});
      this.props.onFetchItemRepair(tradeId);
    }
  }

  onFetchProblem = () => {
    if (this.state.itemRepair || this.props.woInformation.itemToRepair) {
      const itemToRepairId = this.props.woInformation.itemToRepair ? this.props.woInformation.itemToRepair.id : this.state.itemRepair.value;
      this.setState({isLoadingProblem: true});
      this.props.onFetchProblem(itemToRepairId);
    }
  }

  onFetchWOT = () => {
    this.setState({isLoadingWorkOrderType: true});
    this.props.onFetchWOT();
  }

  userTemplate = (item) => {
    if (item.value) {
      return item.text + ' (' + item.extensionValue.email + ')';
    }
    return null;
  }

  onSubmit = (e, type) => {
    e.preventDefault();
    const { trade, subcontractor, itemRepair, problem, user, wot } = this.state;
    const { woInformation } = this.props;

    if(this.props.BulkSendWORFSpage && this.props.BulkSendWORFSpage == true){
      let params = {
        tradeId: trade ? trade.value : null,
        itemToRepairId: itemRepair ? itemRepair.value : null,
        subcontractorId: null,
        assignedUserId: null,
        problemId: problem ? problem.value : null,
        workOrderTypeId: wot ? wot.value : null,
        status: 'Open'
      };

      if (this.state.isModeAssignSub) {
        params.subcontractorId = subcontractor ? subcontractor.value : null;
      } else {
        params.assignedUserId = user ? user.value : null;
      }
        
      this.props.onSubmit(type, params);
    }else{
      let params = {
        tradeId: woInformation.trade ? woInformation.trade.id : trade.value,
        itemToRepairId: woInformation.itemToRepair ? woInformation.itemToRepair.id : itemRepair.value,
        subcontractorId: null,
        assignedUserId: null,
        problemId: woInformation.problem ? woInformation.problem.id : problem.value,
        workOrderTypeId: null,
        status: ''
      };

      if (type === 'open') {
        params.workOrderTypeId = woInformation.workOrderType ? woInformation.workOrderType.id : wot.value;
        if (woInformation.subcontractorProfile) {
          params.subcontractorId = woInformation.subcontractorProfile.subcontractorId;
        }
        else if (woInformation.assignedUser) {
          params.assignedUserId = woInformation.assignedUser.id;
        }
        else {
          if (this.state.isModeAssignSub) {
            params.subcontractorId = subcontractor.value;
          } else {
            params.assignedUserId = user.value;
          }
        }

        params.status = 'Open';
        this.props.onSubmit(type, params);
      } else {
        params.workOrderTypeId = woInformation.workOrderType ? woInformation.workOrderType.id : null;
        params.subcontractorId = woInformation.subcontractorProfile ? woInformation.subcontractorProfile.subcontractorId : null;
        params.assignedUserId = woInformation.assignedUser ? woInformation.assignedUser.id : null;
        params.status = 'Pending';
        this.props.onSubmit(type, params);
      }
    }
  }

  renderForm(isOpen) {
    const type = isOpen ? 'open' : 'pend';
    const labelFile = {
      trade: 'Trade',
      subcontractor: 'Subcontractor',
      itemRepair: 'Item to repair',
      problem: 'Problem',
      workOrderType: 'Work order type'
    };

    const { trade, subcontractor, itemRepair, problem, user, wot } = this.state;
    const { woInformation } = this.props;

    const disabledOpenBtn = !((woInformation.trade || trade) &&
      (woInformation.itemToRepair || itemRepair) &&
      ((woInformation.subcontractorProfile || subcontractor) || (woInformation.assignedUser || user)) &&
      (woInformation.problem || problem) &&
      (woInformation.workOrderType || wot));

    const disabledPendBtn = !((woInformation.trade || trade) &&
      (woInformation.itemToRepair || itemRepair) &&
      (woInformation.problem || problem));

    return (
      <div style={{ paddingTop: 10, paddingBottom: 10 }}>
        <p style={{paddingLeft: 15, fontSize: 14}}>To  {this.props.isOpen ? 'send' : 'hold'} a work order, you must specify the field(s) below.</p>
        {this.props.requireFormField.map((item, index) => {
          switch (item) {
            case 'trade':
              return (
                <div className='form-group' key={index}>
                  <div className='col-sm-12 col-xs-12'>
                    <label
                      className='col-xs-12'>{labelFile[item]}:</label>
                    <div className='col-xs-12'>
                      <Dropdown
                        onChange={ref => { this.onSelectChange(ref, item); }}
                        filter={true}
                        className='filestring-dropdown filter-dropdown'
                        onRemote={this.onFetchTrade}
                        options={this.state.tradeList}
                        loading={this.state.isLoadingTrade}
                        optionLabel='text'
                        value={this.state.trade}
                        placeholder='-- Please select'
                        style={{ width: '100%', paddingLeft: 10, paddingRight: 10, margin: 0 }}
                      />
                    </div>
                  </div>
                </div>
              );
            case 'problem':
              return (
                <div className='form-group' key={index}>
                  <div className='col-sm-12 col-xs-12'>
                    <label
                      className='col-xs-12'>{labelFile[item]}:</label>
                    <div className='col-xs-12'>
                      <Dropdown
                        onChange={ref => { this.onSelectChange(ref, item); }}
                        filter={true}
                        className='filestring-dropdown filter-dropdown'
                        onRemote={this.onFetchProblem}
                        options={this.state.problemList}
                        disabled={!this.state.itemRepair && !woInformation.itemToRepair}
                        loading={this.state.isLoadingProblem}
                        optionLabel='text'
                        value={this.state.problem}
                        placeholder='-- Select an item to repair first'
                        style={{ width: '100%', paddingLeft: 10, paddingRight: 10, margin: 0 }}
                      />
                    </div>
                  </div>
                </div>
              );
            case 'assigned':
              if (type === 'open') {
                return (
                  <div className='form-group' key={index}>
                    <div className='col-sm-12 col-xs-12'>
                      <div className='col-xs-12' style={{marginBottom: 5}}>Assigned to
                        <div className='btn-group btn-group-sm wo-assign-btn-group' role='group'>
                          <button
                            type='button'
                            style={{
                              backgroundColor: this.state.isModeAssignSub
                                ? "#4267b2"
                                : "",
                              color: this.state.isModeAssignSub ? "#fff" : "",
                            }}          
                            className={'btn btn-secondary ' + (this.state.isModeAssignSub ? 'active' : '')}
                            onClick={() => {this.handleModeAssign('sub');}}>subcontractor</button>
                          <button
                            type='button'
                            style={{
                              backgroundColor: !this.state.isModeAssignSub
                                ? "#4267b2"
                                : "",
                              color: !this.state.isModeAssignSub ? "#fff" : "",
                            }}          
                            className={'btn btn-secondary ' + (!this.state.isModeAssignSub ? 'active' : '')}
                            onClick={() => {this.handleModeAssign('user');}}>internal user</button>
                        </div>
                      </div>
                      <div className='col-xs-12'>
                        {this.state.isModeAssignSub
                          ? (
                            <Dropdown
                              onChange={ref => { this.onSelectChange(ref, 'subcontractor'); }}
                              filter={true}
                              className='filestring-dropdown filter-dropdown'
                              onRemote={this.onFetchSubcontractor}
                              options={this.state.subcontractorList}
                              optionLabel='text'
                              value={this.state.subcontractor}
                              loading={this.state.isLoadingSubcontractor}
                              disabled={!this.state.trade && !woInformation.trade}
                              name='subcontractor'
                              placeholder='--Select a trade first'
                              style={{ width: '100%', paddingLeft: 10, paddingRight: 10, margin: 0 }} />
                          ) : (
                            <Dropdown
                              onChange={ref => { this.onSelectChange(ref, 'user'); }}
                              filter={true}
                              className='filestring-dropdown filter-dropdown'
                              onRemote={this.onFetchUser}
                              options={this.state.isFetchedUser ? this.state.userList : [{...this.state.user}]}
                              itemTemplate={this.userTemplate}
                              labelTemplate={this.userTemplate}
                              loading={this.state.isLoadingUser}
                              optionLabel='text'
                              value={this.state.user}
                              name='user'
                              placeholder='--Select a user'
                              style={{ width: '100%', paddingLeft: 10, paddingRight: 10, margin: 0 }} />
                          )}
                      </div>
                    </div>
                  </div>
                );
              } else {
                return null;
              }
            case 'workOrderType':
              if (type === 'open') {
                return (
                  <div className='form-group' key={index}>
                    <div className='col-sm-12 col-xs-12'>
                      <label
                        className='col-xs-12'>{labelFile[item]}:</label>
                      <div className='col-sm-12'>
                        <Dropdown
                          onChange={ref => { this.onSelectChange(ref, 'wot'); }}
                          className='filestring-dropdown filter-dropdown'
                          onRemote={this.onFetchWOT}
                          options={this.props.workOrderTypeList}
                          loading={this.state.isLoadingWorkOrderType}
                          optionLabel='text'
                          value={this.state.wot}
                          name='workOrderType'
                          placeholder='--Please select'
                          style={{ width: '100%', paddingLeft: 10, paddingRight: 10, margin: 0 }} />
                      </div>
                    </div>
                  </div>
                );
              } else {
                return null;
              }
            case 'itemRepair':
              return (
                <div className='form-group' key={index}>
                  <div className='col-sm-12 col-xs-12'>
                    <label
                      className='col-xs-12'>{labelFile[item]}:</label>
                    <div className='col-xs-12'>
                      <Dropdown
                        onChange={ref => { this.onSelectChange(ref, item); }}
                        filter={true}
                        className='filestring-dropdown filter-dropdown'
                        onRemote={this.onFetchItemRepair}
                        options={this.state.itemRepairList}
                        loading={this.state.isLoadingItemToRepair}
                        disabled={!this.state.trade && !woInformation.trade}
                        optionLabel='text'
                        value={this.state.itemRepair}
                        placeholder='-- Select a trade first'
                        style={{ width: '100%', paddingLeft: 10, paddingRight: 10, margin: 0 }}
                      />
                    </div>
                  </div>
                </div>
              );

            default:
              return null;
          }
        })
        }

        <div className='col-xs-12' style={{ paddingBottom: 10 }}>
          <ul className='wo-popup-bottom-btn' style={{ paddingLeft: 5, marginTop: 0, borderTop: 0 }}>
            <li>
              <button
                className='btn btn-primary btn-siteone-default btn-wo-edit'
                onClick={this.props.onCancelPopup}>
                Cancel
              </button>
            </li>
            {
              type === 'pend' &&
              <li>
                <button
                  className='btn btn-primary btn-siteone'
                  disabled={disabledPendBtn}
                  onClick={(e) => this.onSubmit(e, 'pend')}>
                  Save & Pending
                </button>
              </li>
            }
            {
              type === 'open' &&
              <li>
                <button
                  className='btn btn-primary btn-siteone'
                  disabled={disabledOpenBtn}
                  onClick={(e) => this.onSubmit(e, 'open')}>
                  Save & Send
                </button>
              </li>
            }
          </ul>
        </div>
      </div>
    );
  }

  popupStyle = (isOpen, isHasAssignedTo, isHasWorkOrderType, numberOfField) => {
    if (isOpen) {
      return {
        width: 500,
        top: -170 - 88 * numberOfField,
        left: 150,
        paddingTop: 10
      };
    } else {
      let style = {
        width: 500,
        left: 150,
        paddingTop: 10
      };
      if (isHasAssignedTo) {
        if (isHasWorkOrderType) {
          style['top'] = -170 - 88 * (numberOfField - 2);
        } else {
          style['top'] = -170 - 88 * (numberOfField - 1);
        }
      } else {
        if (isHasWorkOrderType) {
          style['top'] = -170 - 88 * (numberOfField - 1);
        } else {
          style['top'] = -170 - 88 * numberOfField;
        }
      }
      return style;
    }
  }

  render() {
    return (
      <Popup
        ref={(ref) => { this.openPopup = ref; }}
        isHasFaded={true}
        styles={this.popupStyle(
          this.props.isOpen,
          this.props.requireFormField.includes('assigned'),
          this.props.requireFormField.includes('workOrderType'),
          this.props.requireFormField.length)}>
        <Form className='form-horizontal' ref={ref => { this.form = ref; }} onSubmit={this.onSubmit}>
          {this.renderForm(this.props.isOpen)}
        </Form>
      </Popup>
    );
  }
}

export default OpenAwaitPopup;



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/OpenAwaitPopup.js